import React from 'react'
import { cn } from '@/lib/utils'
import { DEFAULT_CHART_MARGIN, valueToPlotTop } from './chart-axis-utils'

const StickyReferenceLineLabels = ({
  referenceLinesData = [],
  chartHeight = 600,
  yMin,
  yMax,
  rightOffset = 0,
  showPercentage = false,
  className,
  margin = DEFAULT_CHART_MARGIN,
}) => {
  return (
    <div
      className={cn(
        'absolute right-0 top-0 h-full flex flex-col pointer-events-none',
        className,
      )}
      style={{ height: chartHeight, width: 'auto', right: rightOffset }}
    >
      {referenceLinesData.map((line, index) => {
        if (line.y === undefined || line.value === undefined) return null

        const topPosition = valueToPlotTop(
          line.y,
          yMin,
          yMax,
          chartHeight,
          margin,
        )

        return (
          <div
            key={index}
            className="absolute text-xs pointer-events-auto"
            style={{
              top: `${topPosition}px`,
              right: 0,
              transform: 'translateY(-50%)',
              textAlign: 'left',
              whiteSpace: 'nowrap',
              color: line.fill || 'currentColor',
            }}
          >
            {line.value}
          </div>
        )
      })}
    </div>
  )
}

export default StickyReferenceLineLabels
